import React from 'react';
import colorPalette from '../themes/colorPalette';
import { ClaimStatusTypes } from '../enums/ClaimTypes';
import TextLabel from './TextLabel';
import useColor from '../hooks/useColor';

const { blue, green } = colorPalette;

const claimStatusColors = {
  Open: {
    color: green[9],
    backgroundColor: green[2],
  },
  Closed: {
    color: blue[3],
    backgroundColor: blue[9],
  },
  New: {
    color: green[9],
    backgroundColor: green[2],
  },
};

type ClaimStatusProps = {
  claimStatus: ClaimStatusTypes;
  claimStatusTranslation: any;
};

const ClaimStatus = ({
  claimStatus,
  claimStatusTranslation,
  ...other
}: ClaimStatusProps) => {
  const { color, backgroundColor } = useColor(claimStatusColors, claimStatus);
  return (
    <TextLabel
      color={color}
      bgcolor={backgroundColor}
      fontSize="15px"
      {...other}
    >
      {claimStatusTranslation ?? claimStatus}
    </TextLabel>
  );
};

export default ClaimStatus;
